import { CharField, ImageField, SingleSelectField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Media } from "../../types"
import { FileField } from "../../components/FileField"

export default function MediaForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Media>()

  const mediaTypeOptions = [
    { label: "Immagine", value: "IMAGE" },
    { label: "Video", value: "VIDEO" },
    { label: "Documento", value: "DOC" },
  ]

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <SingleSelectField
        label="Tipo di media"
        layout="horizontal"
        options={mediaTypeOptions}
        value={mediaTypeOptions.find((option) => option.value === values.media_type) || null}
        onChange={(value) => {
          setFieldValue("media_type", value?.value || "")
        }}
        isValid={submitCount > 0 ? !getIn(errors, "media_type") : undefined}
        errorMessage={getIn(errors, "media_type")}
        required
        placeholder="Seleziona un tipo di media"
      />
      <CharField
        label="Titolo"
        layout="horizontal"
        value={values.title}
        onChange={(value) => {
          setFieldValue("title", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "title") : undefined}
        errorMessage={getIn(errors, "title")}
      />
      {values.media_type === "IMAGE" && (
        <ImageField
          label="Immagine"
          layout="horizontal"
          value={values.media_file}
          onChange={(value) => {
            setFieldValue("media_file", value)
          }}
          isValid={submitCount > 0 ? !getIn(errors, "media_file") : undefined}
          errorMessage={getIn(errors, "media_file")}
        />
      )}
      {values.media_type !== "IMAGE" && values.media_type && (
        <FileField
          label="File"
          layout="horizontal"
          value={values.media_file}
          onChange={(value) => {
            setFieldValue("media_file", value)
          }}
          isValid={submitCount > 0 ? !getIn(errors, "media_file") : undefined}
          errorMessage={getIn(errors, "media_file")}
        />
      )}
    </Col>
  )
}
